import { AbstractControl, ValidatorFn } from '@angular/forms';
import { CipoDateTimeControl } from '@shared/components/fields/common';
import moment from 'moment';

export type ValidatorResponse = { [key: string]: any };

export class CipoValidators {
  static requireMinOne(control: AbstractControl): ValidatorResponse {
    if (control.value?.length) {
      return null;
    }

    return {
      requiredMinOne: true,
    };
  }

  static secondGreaterThanFirstValidator(getFirst: () => number | null) {
    return (control: AbstractControl): ValidatorResponse | null => {
      const second = control.value;
      const first = getFirst();
      if (second != null && first != null && second <= first) {
        return { secondLessThanFirst: true };
      }
      return null;
    };
  }

  static minDate(date: string): ValidatorFn {
    return (control: CipoDateTimeControl): ValidatorResponse | null => {
      if (!date) {
        return null; // Consider validation as success if minDate is missing
      }

      if (control.value) {
        const controlDate = moment(control.value);
        const minDate = moment(date);

        if (controlDate.isBefore(minDate, 'day')) {
          return { minDate: true };
        }

        return null;
      }

      return null; // Return null if control has no value
    };
  }

  static maxDate(date: string): ValidatorFn {
    return (control: CipoDateTimeControl): ValidatorResponse | null => {
      if (control.value) {
        const controlDate = moment(control.value);
        const maxDate = moment(date);

        if (controlDate.isAfter(maxDate, 'day')) {
          return { maxDate: true };
        }

        return null;
      }

      return null; // Return null if control has no value
    };
  }

  static eachElementMin(min: number): ValidatorFn {
    return (control: AbstractControl): ValidatorResponse | null => {
      if (Array.isArray(control.value) && (control.value as number[]).length && min != null) {
        const invalid = (control.value as number[]).some(val => val < min);
        if (invalid) {
          return { min };
        }
      }
      else if (!Array.isArray(control.value) && control.value != null && min != null) {
        if (control.value < min) {
          return { min };
        }
      }
      return null;
    };
  }

  static eachElementMax(max: number): ValidatorFn {
    return (control: AbstractControl): ValidatorResponse | null => {
      if (Array.isArray(control.value) && (control.value as number[]).length && max != null) {
        const invalid = (control.value as number[]).some(val => val > max);
        if (invalid) {
          return { max };
        }
      }
      else if (!Array.isArray(control.value) && control.value != null && max != null) {
        if (control.value > max) {
          return { max };
        }
      }
      return null;
    };
  }
}
